import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { PrintableFormatListContainerModel } from '../../../../../models/aggregates/print';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, ApiVisa } from "../shared";
import { PrintableFormatCriteriaModelQuery, PrintableFormatQueryCriteriaClass } from '../../criteria';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PrintableFormatListService extends BaseApiTemplateService<PrintableFormatListContainerModel> {

  readonly subUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PRINT_PREFIX + 'printable-format-lists';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.subUrl;
    this.endpoint_path = this.subUrl;
    this.httpClient = http;
  }

  getByCriteriaObservable(visa: ApiVisa, criteria?: PrintableFormatQueryCriteriaClass): Observable<ApiResponseModel<PrintableFormatListContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildCriteria = new PrintableFormatCriteriaModelQuery(criteria);
    return this.httpClient.get<ApiResponseModel<PrintableFormatListContainerModel>>(
      this.apiUrl + "/query?" + buildCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
